import React from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";

interface Props {
  isOpenModal: boolean;
  handleOpenModal: () => void;
  handlerFunc: () => void;
}

const DialogRendering: React.FC<Props> = ({
  isOpenModal,
  handleOpenModal,
  handlerFunc,
}: Props) => {
  return (
    <Dialog
      open={isOpenModal}
      handler={handleOpenModal}
      className="dialog-scss"
    >
      <DialogHeader className="text-xl">Xác Nhận Chỉnh Sửa</DialogHeader>
      <DialogBody divider>
        Bạn có chắc chắn muốn chỉnh sửa thông tin Voucher không?
      </DialogBody>
      <DialogFooter className="flex gap-3">
        <button className="check-time-activated" onClick={handleOpenModal}>
          Hủy
        </button>
        <button className="check-another-activated" onClick={handlerFunc}>
          Xác Nhận
        </button>
      </DialogFooter>
    </Dialog>
  );
};

export default DialogRendering;
